import Header from "../../../../components/common/header";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import clsx from "clsx";
import { getCDNResizedImageUrl } from "../../../../utils/get-cdn-resized-image-url";
import { track } from "@amplitude/analytics-browser";

const SignupServiceOverview = () => {
  const navigate = useNavigate();
  const [image1Loaded, setImage1Loaded] = useState(false);
  const [image2Loaded, setImage2Loaded] = useState(false);

  return (
    <div className="flex flex-col min-h-screen h-full bg-white">
      <Header title="입점 신청" />

      <div className="flex flex-col p-4 h-full overflow-auto">
        <div className="w-full space-y-6">
          <div className="space-y-1">
            <h1 className="text-3xl font-bold break-keep">
              마감히어로 이용 방법에 대해 간단히 알려드릴게요
            </h1>
          </div>

          <div className="space-y-4">
            <div className="bg-white border border-gray-300 rounded-xl p-5 space-y-4">
              <h2 className="font-bold text-2xl">
                1. 마감히어로는 어떤 서비스인가요?
              </h2>

              <p className="text-gray-900 text-xl">
                마감히어로는 마감 시간 전 남은 상품을 간편하게 판매할 수 있도록
                도와주는 플랫폼입니다.
              </p>
            </div>

            {!image1Loaded && (
              <div className="w-4/5 mx-auto">
                <Skeleton className="w-full rounded-xl aspect-square" />
              </div>
            )}
            <div className="w-full flex justify-center">
              <img
                src={getCDNResizedImageUrl(
                  "https://s3.ap-northeast-2.amazonaws.com/cdn-mahi.com/250326-reserve-pack-onboarding1.jpg",
                  { width: 600 },
                )}
                alt="reserve-pack"
                className={clsx(
                  "w-4/5 rounded-xl aspect-square object-cover",
                  image1Loaded ? "opacity-100" : "opacity-0",
                )}
                onLoad={() => setImage1Loaded(true)}
              />
            </div>

            <div className="bg-white border border-gray-300 rounded-xl p-5 space-y-4">
              <h2 className="font-bold text-2xl">2. 어떻게 판매하나요?</h2>

              <p className="text-gray-900 text-xl">
                · 당일 남은 상품을 랜덤으로 팩에 담아 판매하시면 됩니다.
              </p>
              <p className="text-gray-900 text-xl">
                · 남은 음식이 없는 경우, 픽업시간 30분 전까지는 자유롭게 주문
                취소가 가능합니다.(취소를 하지 않을 경우 손님에게 자동으로 예약
                확정 연락이 발송됩니다.)
              </p>
            </div>

            {!image2Loaded && (
              <div className="w-4/5 mx-auto">
                <Skeleton className="w-full rounded-xl aspect-square" />
              </div>
            )}
            <div className="w-full flex justify-center">
              <img
                src={getCDNResizedImageUrl(
                  "https://s3.ap-northeast-2.amazonaws.com/cdn-mahi.com/250326-reserve-pack-onboarding2.jpg",
                  { width: 600 },
                )}
                alt="reserve-pack"
                className={clsx(
                  "w-4/5 rounded-xl aspect-square object-cover",
                  image2Loaded ? "opacity-100" : "opacity-0",
                )}
                onLoad={() => setImage2Loaded(true)}
              />
            </div>

            <div className="bg-white border border-gray-300 rounded-xl p-5 space-y-4">
              <h2 className="font-bold text-2xl">
                3. 어떤 과정으로 판매되나요?
              </h2>

              <p className="text-gray-900 text-xl">
                매장 등록을 완료하면 손님은 앱에서 상품을 예약, 결제할 수
                있습니다. 등록한 정보는 마감히어로 앱에 바로 노출되며, 손님은{" "}
                <span className="font-bold">사장님이 설정한 픽업시간 내에</span>{" "}
                방문하여 수령합니다.
              </p>
            </div>

            <div className="bg-white border border-gray-300 rounded-xl p-5 space-y-4">
              <h2 className="font-bold text-2xl">
                4. 판매 가격은 어떻게 정하나요?
              </h2>
              <p className="text-gray-900 text-xl">
                랜덤팩의 가격은 마음대로 설정이 가능하며,{" "}
                <span className="font-bold">
                  정가의 55% 또는 60% 할인 된 가격
                </span>
                으로 마감히어로에서 판매됩니다.
              </p>
            </div>

            <div className="bg-white border border-gray-300 rounded-xl p-5 space-y-4">
              <h2 className="font-bold text-2xl">
                5. 수수료와 정산은 어떻게 되나요?
              </h2>
              <p className="text-gray-900 text-xl">
                ✅ 사장님께는 <span className="font-bold"> 수수료 9% 고정</span>
                <br />
                <span className="font-bold">
                  ✅ 전월 거래내역을 기준으로{" "}
                  <span className="font-bold text-primary">월 1회</span> 영업일
                  기준 첫날 자동 정산됩니다.
                </span>
              </p>
            </div>
          </div>
          <div>
            <button
              onClick={() => {
                track(
                  "사장님 입점신청7 예약판매 온보딩 이해했습니다 버튼 클릭",
                );
                navigate("/boss/signup/reserve-pack/pack");
              }}
              className="w-full py-3 bg-primary text-white font-semibold rounded-xl transition duration-150"
            >
              이해했습니다!
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignupServiceOverview;
